import { userTypes } from '../types'


const initialState = {
    loggedIn: false,
    userDetails: {}
};

export function authentication(state = initialState, action) {
    switch (action.type) {
        case userTypes.AUTHENTICATION:
            return {
                ...state,
                loggedIn: action.payload,
            };
        case userTypes.LOGIN_OR_SIGNUP:
            return {
                ...state,
                userDetails: {
                    planyoUserId: state?.userDetails?.planyoUserId,
                    cdcId: state?.userDetails?.cdcId,
                    userId: state?.userDetails?.userId,
                    userSessionId: state?.userDetails?.userSessionId,
                    ...action.payload
                }
            };
        case userTypes.SET_PLANYO_USER_ID:
            return {
                ...state,
                userDetails: {
                    ...state?.userDetails,
                    planyoUserId: action.payload
                }
            }
        case userTypes.SET_CDC_ID:
            return {
                ...state,
                userDetails: {
                    ...state?.userDetails,
                    cdcId: action.payload
                }
            }
        case userTypes.SET_USER_ID:
            return {
                ...state,
                userDetails: {
                    ...state?.userDetails,
                    userId: action.payload
                }
            }
        case userTypes.SET_USER_SESSION_ID:
            return {
                ...state,
                userDetails: {
                    ...state?.userDetails,
                    userSessionId: action.payload
                }
            }
        case userTypes.LOGOUT:
            return initialState;
        default:
            return state
    }
}